// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__9CbSo","errorLogs":"styles_errorLogs__3p8w0"};